import {useCallback} from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {prependBackendUrl} from '../gql/client'
import {useGetUser} from '../store/userStore'

/**
 * CID del logo que el backend adjunta al enviar el correo.
 *
 * Las plantillas de email lo referencian como `<img src="cid:logo_cid">`; al
 * enviar, el backend adjunta la imagen inline con esta prioridad: logo de
 * plantillas de la organización → logo de la organización → logo del usuario →
 * `static/img/logo.png` (ver `resolve_logo` en core/services/email.py). Es el
 * mismo mecanismo de los correos de notificación del sistema.
 */
export const EMAIL_LOGO_CID = 'cid:logo_cid'

/** Logo de la app, para cuando la organización no tiene uno cargado. */
export const FALLBACK_PREVIEW_LOGO = '/media/tfi/logo_policytools.png'

/**
 * Devuelve una función que sustituye el `cid:` por el logo de la organización.
 *
 * `cid:` solo resuelve dentro del correo ya enviado, así que en las vistas
 * previas del navegador se muestra el mismo logo que embebería el backend, en
 * el mismo orden de prioridad.
 */
export const useEmailPreviewLogo = () => {
  const currentUser = useGetUser((s) => s.user?.user)
  const logoUrl =
    (currentUser?.organizationTemplateLogo &&
      prependBackendUrl(currentUser.organizationTemplateLogo)) ||
    (currentUser?.organization?.templateLogo &&
      prependBackendUrl(currentUser.organization.templateLogo)) ||
    (currentUser?.organization?.logo && prependBackendUrl(currentUser.organization.logo)) ||
    toAbsoluteUrl(FALLBACK_PREVIEW_LOGO)

  return useCallback(
    (html: string): string => html.split(EMAIL_LOGO_CID).join(logoUrl),
    [logoUrl]
  )
}
